import { create } from '@bufbuild/protobuf'
import { atom, useAtomValue, useSetAtom } from 'jotai'

import { Member, MemberSchema } from '~/gen/proto/bff/v1/model_pb'
import { MemberEditSchema } from '~/pages/Members/components/MemberEdit/memberEditSchema'

type MemberMutationAtom = {
  observed: Readonly<Member>
  editing: Member
}

type MemberAtom = {
  [id: string]: MemberMutationAtom
}

const memberAtom = atom<MemberAtom>({})

type MemberMutationState = {
  start: (member: Member) => Member
  edited: (formValue: MemberEditSchema) => void
  discard: () => void
  getObserved: () => Readonly<Member> | undefined
  getEditing: () => Member | undefined
}

export const useMemberMutationState = (
  memberId: string,
): MemberMutationState => {
  const set = useSetAtom(memberAtom)
  const data = useAtomValue(memberAtom)[memberId]

  const start = (member: Member): Member => {
    set((): MemberAtom => {
      return {
        [memberId]: {
          observed: structuredClone(member),
          editing: structuredClone(member),
        },
      }
    })
    return member
  }
  const getObserved = (): Readonly<Member> | undefined => {
    return data?.observed
  }
  const edited = (formValue: MemberEditSchema): void => {
    data.editing = create(MemberSchema, {
      ...data.editing,
      ...formValue,
      userRoleCodes: formValue.userRoleSettings
        .flat()
        .map((role) => role.value),
    })
  }
  const discard = (): void => {
    delete data[memberId]
  }
  const getEditing = (): Member | undefined => {
    return data?.editing
  }

  return {
    start,
    edited,
    discard,
    getObserved,
    getEditing,
  }
}
